function fitValidator(fit) {
  return ['fill', 'contain', 'cover', 'none', 'scale-down'].includes(fit);
}

export var props = {
  src: {
    type: String
  },
  fit: {
    type: String,
    validator: fitValidator,
    default: 'cover'
  },
  height: {
    type: [String, Number]
  },
  alt: {
    type: String
  },
  title: {
    type: String
  },
  subtitle: {
    type: String
  },
  description: {
    type: String
  },
  elevation: {
    type: [Number, String]
  },
  ripple: {
    type: Boolean,
    default: false
  },
  onClick: {
    type: Function
  }
};